import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
} from "recharts";
import type { ChartLineSeries, ChartDataPoint } from "../../types/reports.types";

interface TrendChartProps {
  data?: ChartDataPoint[];
  lines?: ChartLineSeries[];
  loading?: boolean;
}

export default function TrendChart({
  data = [],
  lines = [],
  loading = false,
}: TrendChartProps) {
  if (loading) {
    return <div className="chartState">Loading chart...</div>;
  }

  if (!data.length || !lines.length) {
    return <div className="chartState empty">No trend data available</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e6edf4" />
        <XAxis dataKey="name" tick={{ fontSize: 10 }} />
        <YAxis tick={{ fontSize: 10 }} />
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 10 }} />
        {lines.map((series) => (
          <Line
            key={series.dataKey}
            type="monotone"
            dataKey={series.dataKey}
            name={series.name}
            stroke={series.color}
            strokeWidth={2}
            dot={{ r: 3 }}
            isAnimationActive
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
